import React from "react";
import { Routes, Route } from "react-router-dom";
import { AdminDashboard } from "./AdminDashboard";
import { AdminListUsersPage } from "./AdminListUsersPage";
import { AdminOrganizationsPage } from "./AdminOrganizationsPage";
import { AdminExtractedDataPage } from "./AdminExtractedDataPage";
import { AdminActionLogPage } from "./AdminActionLogPage";
import { AdminCommandsPage } from "./AdminCommandsPage";
import { AdminFeedbackPage } from "./AdminFeedbackPage";
import AdminConfigListPage from "./AdminConfigListPage";
import AdminConfigEditPage from "./AdminConfigEditPage";
import { ShipmentsDashboardMonitorPage } from "./shipments/ShipmentsDashboardMonitor";
import { AdminRemindersPage } from "./remindersAndActionsAdminDashboard/AdminRemindersPage";
import { ShipmentEmailCategoryValidationPage } from "./shipmentEmailCategoryValidation/ShipmentEmailCategoryValidationPage";

// System Admin imports
import EntryEditor from "./database/EntryEditor";
import RequestsList from "./requests";
import Request from "./request";
import { InternalEmailThreadPage } from "./email/InternalEmailThreadPage";
import { QuoteEmailsInternalPage } from "./email/QuoteEmailsInternalPage";
import { SearchMessagesInternalPage } from "./email/SearchMessagesInternalPage";
import { EmailTestSetsPage } from "./email/EmailTestSetsPage";
import { EmailTestSetDetailPage } from "./email/EmailTestSetDetailPage";
import { EmailAutomationPipelineRoutes } from "./emailAutomationPipeline/routes";
import WorkflowsList from "./workflows";
import { MessagesWithExtractedDataFromJobPage } from "./MessagesWithExtractedDataFromJobPage";
import { MockOutlookPluginAdminPage } from "./msoffice/MockOutlookPluginAdminPage";
import { AdminPermissionGroupsPage } from "./AdminPermissionGroupsPage";
import { AdminFeatureFlagsPage } from "./AdminFeatureFlagsPage";

function AdminRoutes() {
  return (
    <Routes>
      {/* Admin Dashboard */}
      <Route path="/" element={<AdminDashboard />} />

      {/* Core Admin Pages */}
      <Route path="/list_users" element={<AdminListUsersPage />} />
      <Route path="/organizations" element={<AdminOrganizationsPage />} />
      <Route path="/extracted-data" element={<AdminExtractedDataPage />} />
      <Route path="/action-logs" element={<AdminActionLogPage />} />
      <Route path="/commands" element={<AdminCommandsPage />} />
      <Route path="/feedback" element={<AdminFeedbackPage />} />
      <Route path="/configs" element={<AdminConfigListPage />} />
      <Route
        path="/configs/edit/:configName"
        element={<AdminConfigEditPage />}
      />
      <Route
        path="/shipments-dashboard-monitor"
        element={<ShipmentsDashboardMonitorPage />}
      />
      <Route path="/reminders" element={<AdminRemindersPage />} />
      <Route
        path="/shipment-email-category-validation"
        element={<ShipmentEmailCategoryValidationPage />}
      />

      {/* System Admin Pages (from internal) */}

      {/* Workflows Routes */}
      <Route path="/workflows" element={<WorkflowsList />} />

      {/* DB Routes */}
      <Route path="/database" element={<EntryEditor />} />
      <Route
        path="/database/:collectionName/:documentId"
        element={<EntryEditor />}
      />

      {/* LLM Request Routes */}
      <Route path="/requests" element={<RequestsList />} />
      <Route path="/request/:id" element={<Request />} />

      {/* Email Routes */}
      <Route path="/email/search" element={<SearchMessagesInternalPage />} />
      <Route path="/email/thread/:id" element={<InternalEmailThreadPage />} />
      <Route
        path="/email/message/:id"
        element={<InternalEmailThreadPage useMessageId />}
      />
      <Route
        path="/email/job/messages_with_extracted_data"
        element={<MessagesWithExtractedDataFromJobPage />}
      />
      <Route path="/email/quotes/all" element={<QuoteEmailsInternalPage />} />
      <Route path="/test-sets" element={<EmailTestSetsPage />} />
      <Route
        path="/test-sets/:testSetId"
        element={<EmailTestSetDetailPage />}
      />

      {/* Email Automation Pipeline */}
      <Route
        path="/email-automation/*"
        element={<EmailAutomationPipelineRoutes />}
      />

      {/* Permission Groups */}
      <Route path="/permission-groups" element={<AdminPermissionGroupsPage />} />

      {/* Feature Flags */}
      <Route path="/feature-flags" element={<AdminFeatureFlagsPage />} />

      {/* MS Office Plugin */}
      <Route path="/msoffice" element={<MockOutlookPluginAdminPage />} />
    </Routes>
  );
}

export default AdminRoutes;
